import {
    GET_INVENTORY_FBA_FORECAST_LOADING,
    GET_INVENTORY_FBA_FORECAST_SUCCESS

} from '../actions/InventoryFBAForecastActions';

const initialState = {
    inventoryFBAForecastData: null,
    isLoading: true,
};

const InventoryFBAForecastReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_INVENTORY_FBA_FORECAST_SUCCESS:
            return { ...state, inventoryFBAForecastData: action.data, isLoading: false };

        case GET_INVENTORY_FBA_FORECAST_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default InventoryFBAForecastReducer;
